const header = {
    user: "User Info",
    logout: "Logout",
    language: 'Language',
    nameSystem: "CamAI VNS System",
    notification: "Notification",
    checkAll: "Hide all read",
    setupNotification: "Notification settings",
    chanelNotification: "Notification channel",
    seeAll: "See all notifications",
    systemNotification: "System notification",
    smartNoification: "Smart alert",
    emptyNotification: "No new notifications"
}
const infoUser = {
    header: "Account",
    info: "Info user",
    changePassword: "Change password",
    version: "Version",
    userName: "User Name",
    lastEdit: "Last edit",
    phoneNumber: "Phone number",
    company: "Company",
    email: "Email",
    groupUser: "Group user",
    timeCreate: "Time create",
    avatar: "Avatar",
    upload_avatar: "Upload image",
    change_image_success: "Image changed successfully!",
    change_image_error: "Image change failed!",
    over_size_image: "Photo needs to be less than 10MB",
}

const changePassword = {
    currentPass: "Current Password",
    newPass: "New Password",
    confirmPass: "Re-enter password",
    title: "Over 6 - 20 characters long, including letters, numbers, uppercase, lowercase and special characters",
    emptyError: "Password cannot be empty",
    newPassEmtyError: "New password cannot be empty",
    newPassSameCurrentError: "New password must be different from current password",
    confirmPassEmtyError: "Re-enter password cannot be blank",
    confirmPassNotSameError: "Re-entered password is not the same",
    accept: "Confirm",
    canNotChangePass: "Cannot change password",
    changePassSuccess: "Password changed successfully",
}

const version = {
    mobileVersion: "Mobile version:",
    desktopVersion: "Desktop version:",
    downloadDesktopVersion: "Download VNS CamAI desktop"
}


const home = {
    notification: "Notification",
    cameraOnline: "Active camera"
}

const login = {
    login: "Login",
    typeInfo: "Enter your account information",
    companyCode: "Company code",
    companyCodeEmptyError: "Company code cannot be empty",
    companyCodeType: "Company code contains only uppercase characters and numbers",
    userName: "Email or username",
    userNameEmptyError: "Account name cannot be empty",
    userNameType: "Username is 6 - 15 characters long, contains only lowercase characters and numbers.",
    typePass: "Enter password",
    passEmptyError: "Password cannot be empty!",
    passType: "Password is 6-20 characters long, must contain uppercase letters, lowercase letters, special characters, numbers, and no spaces",
    forgottenPass: "Forgot password?"
}
const sideBar = {
    home: "Home",
    dashboard: "Dashboard",
    live: "Watch live",
    map: "Map",
    playback: "Replay",
    support: "Support",
    smartReport: "Smart alert",
    licensePlate: "License plate recognition",
    controlCam: "Camera control",
    manage: "Camera Administration",
    cameraPermission: "Camera permission",
    company: 'Company',
    wareHouse: 'Warehouse',
    cameraGroup: 'Camera group',
    user: 'User',
    userPermission: 'User Permissions',
    setDefault: 'Set default',
    service: 'Service',
    manageNotifi: "Notification management",
    smallMenu: "Minimize menu",
    faceDetect: "Face recognition",
    ticketManagement: "Ticket Management",
    aiAlert: "AI Alert",
}
const dashboard = {
    liveFeedTitle: "AI Vision Security Monitoring (Live Feed)",
    ticketDispatchTitle: "Incident Dispatch & Ticket Update",
    quickDispatch: "Quick Dispatch",
    internalNote: "Internal Note",
    analystCamera: "Camera Statistics",
    sumCam: "Total Camera",
    online: "Online",
    ready: "Ready",
    lostConnect: "Lost connection",
    analystAI: "AI Statistics",
    motion: "Detect motion",
    object: "Common object",
    move: "Move camera",
    sum: "Total",
    all: 'All',
    noPermission: "You do not have permission to view statistics",
    totalCamGroup: "Total number of Cameras by group",
    totalCamWarehouse: "Total number of Cameras by warehouse",
    nodata: "No statistics available",
    fire:"Fire alrm",
    face:"Face detecion",
    alpr: "License plate recognition",
    paking: "Parking"
}
const stream = {
    customScreenError: "Please select row with minimum column 1",
    stream: "Watch live",
    status: "Status",
    online: "Online",
    lostConect: "Lost connection",
    ready: "Ready",
    screenShow: "Screen display",
    other: "Other",
    col: "Column",
    row: "Row",
    acceptCustom: "Confirm",
    cancelCustom: "Cancel",
    minisizeScreen: "Minimize the screen",
    fullScreen: "Full screen",
    reNameCam: "Rename camera",
    nameCamera: "Camera name",
    type: "Enter",
    cancel: "Cancel",
    save: "Save",
    changePosotionSuccess: "Changed camera position successfully",
    changePosotionError: "Changing camera position only applies to group viewing",
    restartCameraSuccess: "Restart successfully",
    restartCameraError: "Please try again in a few minutes",
    getListServiceError: "Failed to get service list",
    brandNotSupportFireDetect: "The camera brand does not support fire detection",
    turnOn: "Turn on service",
    success: "success",
    noPermissionTurnAI: "You do not have permission to turn AI on/off",
    error: "failed",
    turnOff: "Turn off service",
    infoCamera: "Camera information",
    settingCamera: "Camera settings",
    restart: "Restart",
    playback: "Replay",
    rename: "Rename camera",
    renameCameraSuccess: "Editing successful",
    renameCameraError: "Failed to edit camera name",
    noCamera: "No results found, please select a camera to view",
    refresh: 'Refresh'
}
const location = {
    getCityError: "Unable to download province/city list",
    getDistrictError: "Unable to download district list",
    getCommuneError: "Unable to download ward/commune list",
    groupCam: "Camera group",
    province: "Province",
    district: "District",
    commune: "Ward/Commune",
    status: "Status",
    all: "All",
    record: "Record",
    isRecord: "There is a record",
    noRecord: "No record",
    statusService: "Service status",
    isOn: "On",
    isOff: "Off",
    accept: "Apply",
    group: "Group",
    address: "Location",
    cameraIsOff: "Camera is off",
    changePositionWarehouseSuccess: "Change warehouse position successfully",
    changePositionWarehouseError: "Failed to change warehouse location",
    find: "Search...",
    cameraIsLostConnect: "Camera is losing connection",
    isOnline: "Is Online",
    isOffline: "Offline",
    isLostConnect: 'Connection lost',
    isWeek: "Weak connection",
    seenCam: "See cam",
    noResult: "No matching results were found",
    noResultAlt: "No search results",
    updateSuccess: "Update successful",
    updateError: "Unable to update",
    filter: "Filter",
}
const playback = {
    choseDay: "Choose day",
    timeFrame: "Time frame",
    downLoad: "Download Video",
    downLoading: 'Downloading',
    success: 'Success!',
    error: 'Load failed!',
    gettingVideo: 'Preparing video!',
    videoOverSize: "Cannot download video longer than 2 hours",
    noVideoInTime: 'no videos during the selected time!',
    downloadError: "Download failed",
    emptyTime: 'Please select download time',
    emptyCam: 'Please select at least one cam',
    downloadVideo: "Download video",
    choseTimeError: "Please choose a start date that is smaller than the end date",
    start: "From",
    end: "To",
    cancel: "Cancel",
    down: "Download",
    isOnline: 'Only online',
    isReady: 'Ready',
    isLostConnect: 'Connection lost',
    noPermissionViewCam: "You do not have permission to view the camera list",
    isRecord: 'There is a record',
    accept: "Apply",
    screenView: "Screen display",
    minisize: "Shrink the screen",
    fullsize: "Full screen",
    startDownload: "Start download",
    errorDownloadVideo: "There was an error downloading the video",
    infoCamera: "Camera information",
    settingCamera: "Camera settings",
    downVideo: "Download video",
    noCamera: "No results found, please select a camera to review",
    noPermissionViewInfoCam: "You do not have permission to view camera information",
    playback: "Replay",
}
const infoCamera = {
    updateSuccess: "Update successful",
    updateError: "Update failed",
    needRestart: "The camera lost connection and needs to be restarted!",
    restartSuccess: "Restart successfully",
    restartAfterMinutes: "Please try again in a few minutes",
    type: "Enter",
    cameraName: "Camera name",
    brandName: "Camera Brand",
    typeSetup: "Installation type",
    warehouse: "Warehouse *",
    companyName: "Affiliated company",
    address: "Address",
    resolution: "Main source resolution",
    resolutionPlayback: "Recorded video resolution",
    cameraIsOff: "Camera is off",
    rtsp: "rtsp path *",
    rtpsEmpty: "Please enter the correct rtsp path",
    width: "Width",
    height: "Height",
    subResolution: "Sub source resolution",
    subResolutionEmty: 'No sub source resolution',
    videoDecode: "Video encoding format *",
    accept: "Confirm",
    edit: "Edit",
    cancel: "Cancel",
    settingCamera: "Camera Settings",
    restart: "Restart"
}

const services = {
    licensePlate: "Vehicle license plate recognition",
    cameraMoving: "Detect camera moving",
    fireWarning: "Fire warning",
    faceRecognition: "Face recognition",
    motionDetection: "Motion detection",
    detectCommonObjects: "Detect common objects",
    cameraRestartNotification: "Camera restart notification",
    notificationOfCameraLosingConnection: "Notification of camera losing connection",
    notificationOfWarehouseConnectionLoss: "Notification of warehouse connection loss",
    systemErrorMessage: "System error message",
    eventTracing: "Event Tracing",
    Warehouse_lost_connection: "Warehouse lost connection",
    Camera_reboot: "Camera reboot",
    Camera_lost_connection: "Camera lost connection",
    System_error: "System error",
}

const smartReport = {
    getInfoCamError: "Failed to get camera information",
    viewEvent: 'Review event',
    config: 'Configuration',
    history: 'Warning history',
    setNotifi: 'Set alert',
    statistic: 'Report export statistics',
    viewFireMap: 'View heat map',
    manager: 'General manager',

    find: "Search...",
    statusCam: 'Camera status',
    all: "All",
    statusAi: "AI status",
    on: "On",
    off: 'Off',
    address: "Location",
    group: "Group",
    service: "Service",

    timeError: 'Time selected does not match',
    timeEndGreatStart: 'End time cannot be less than start time',
    getListVideoError: "Failed to get video list",
    downVideoError: 'There was an error downloading the video',
    stt: 'ON',
    time: "Time",
    object: "Object",
    action: "Action",
    noDataMatch: "No matching data",
    shoudChooseCam: "Please select a camera to watch video",
    inprogressBuild: "Functions under development!",

    cantGetListCamera: 'Cannot get camera list',
    cantGetListVideo: 'Cannot get video list',
    restartSuccess: "Restart successfully",
    tryAffterSomeMinute: "Please try again in a few minutes",
    showInfo: "Show information",
    resolution: "Resolution",
    noCamMatch: "No matching cameras",
    chart: "Chart",
    countEventChart: "Event count statistics chart",
    exportReport: "Export report",
    fileType: "Format",
    choseCameraViewStatistics: "Please select a camera to view statistics",
    licensePlate: "License plate",
    licensePlateImage: "License plate image",
    noRecordInTime: "There are no records for the selected time",
    cantGetNotifi: "Cannot get notification",
    content: "Content",
    receiver: "Recipient",
    choseCameraViewNotifi: "Please select a camera to view notifications",
    day: "Day",
    timeStart: "Start time",
    timeEnd: "End time",
    choseCameraConfig: "Please select a camera to configure",
    reciver: "reciver",
}
const faceDetect = {
    deleteDepartment: "Department deleted successfully",
    deleteDepartmentError: "Department deleted unsuccessfully",
    getListDepartment: "Department list retrieved unsuccessfully",
    department: "Department manager",
    alertDeleteDepartment: "Department deletes all objects in the department!",
    nameDepart: "Department name",
    company: "Unit",
    countObject: "Number of objects",
    object: 'Object list',
    getListObjectError: "Object list retrieved unsuccessfully",
    alerRemoveObject: "Do you want to delete the object from this department",
    image: "Image",
    nameEmploy: "Employee name",
    depart: "Department",
    timeAdd: 'Time added to the system',
    removeCamera: "Department deleted successfully",
    removeCameraError: "Department deleted unsuccessfully",
    addCamera: 'Add camera successfully',
    addCameraError: 'Add camera unsuccessful',
    getListCameraError: "Get camera list unsuccessful",
    addCameraToDepart: "Add camera to department",
    addCamera: 'Add camera',
    alertRemoveCamera: "Do you want to remove camera from this department",
    addDepartment: "Add new department successfully",
    addDepartmentError: "Add department unsuccessful",
    validateDepart: "Department name, unit cannot be blank",
    editDepart: 'Edit department successfully',
    editDepartError: 'Edit department unsuccessful',
    editInfo: "Edit information",
    addNew: "Add new",
    addNewDepart: "Add new department",
    findObjectError: "Find object unsuccessful",
    findObject: "Search object",
    nameObject: "Object name",
    getHistoryError: "Get history list unsuccessful",
    historyObject: `Object recognition history`,
    timeDetect: "Time of recognition",
    countValidate: 'Quantity cannot be negative',
    findObjectValidate: "Fill in all the information to search",
    typeError: "not a valid format",
    imageObject: "Object image",
    uploadImage: "Upload image",
    maxObject: "Maximum number of objects returned",
    count: 'Enter quantity',
    find: "Search",
    getInfoError: "Failed to retrieve information",
    choseCamera: 'Select camera to view facial recognition events',
    employName: "Employee name",
    noResource: "Unknown",
    start: "Start",
    end: 'End',
    choseCameraConfig: "Select camera to configure facial recognition",
    variable: 'Processing parameters',
    roiList: "Surveillance area",
    fileLock: "Lock list",
    getListobjectError: "Failed to get object list",
    deleteObject: "Successfully deleted object",
    deleteObjectError: "Failed to delete object",
    alertDelete: "Do you want to delete this object",
    addObject: "Successfully added new object",
    addObjectError: "Failed to add new object",
    validateAddObject: "Department, employee name and photo cannot be empty",
    getInfoObjectError: "Failed to get object information",
    editObject: "Successfully edited object",
    editOnjectError: "Failed to edit object",
    objectNew: "Unknown object",
    detailInfo: "Detailed information",
    Remove_object_from_list_successfully: "Removing object from list successfully",
    Removing_object_from_list_failed: "Removing object from list failed",
    Get_list_of_objects_failed: "Getting list of objects failed",
    Do_you_want_to_delete_this_object: "Do you want to delete this object",
    Object_added_to_lock_list_successfully: "Adding object to lock list successfully",
    Adding_object_to_lock_list_failed: "Adding object to lock list failed",
    Get_list_failed: "Getting list failed",
}
const licensePlate = {
    cantChooseLessTwo: "Do not choose more than two cameras",
    toastTurnOnLisencePlate: "Please turn on license plate recognition service for camera selection",
}
const cameraManager = {
    cameraManager: "Camera Administration",
    statusActive: "Active status",
    addNewCam: "Add new camera",
    active: 'Activate',
    deleted: "Deleted",
    delete: "Delete",
    restore: "Restore camera",
}
const cameraControl = {
    cameraControl: "Camera control",
    reconciliation: "Reconciliation",
    reconcileTotal: "Reconcile total",
    priceList: "Price list",
    taxRate: "Tax rate",
    camHistory: "Camera usage history",
    FTTH_cost: "FTTH cost",
    Labor_Contract_Expenses: "Labor/Contract Expenses",
    New_installation_cost: "New installation cost",
    Increased_cost_of_Cam_new_installation: "Increased cost of Cam (new installation)",
    Connection_cost: "Connection cost",
    Increased_cost_of_cams_connection: "Increased cost of cams (connection)",
    Total_cost_of_services_in_the_month: "Total cost of services in the month",
    VAT_Tax: "VAT Tax",
    Total_after_tax: "Total after tax",
    No_control_data_available: "No control data available",
    Select_all_information: "Select all information marked with * to download the control report",
    Retrieving_information_failed: "Retrieving information failed!",
    Tax: "Tax",
    Choose_a_company: "Choose company",
    Select_invoice_detail_type: "Select invoice detail type",
    Select_year: "Select year",
    Year: "Year",
    Select_month: "Select month",
    Month: "Month",
    View_information: "View information",
    Export_report: "Export report",
    Applicable_information: "Applicable information",
    Price_list_name: "Price list name",
    Tax_code: "Tax code",
    Day_start: "From date",
    Day_end: "Date date",
    Cost: "Cost",
    There_is_no_cost_information: "There is no cost information for the selected period",
    Select_information_to_view_costs: "Select information to view costs",
    Control_details: "Control details",
    No_data_available: "No data available",
    Inventories_decreased_during_the_period: 'Inventories decreased during the period',
    Accumulated_stocks_during_the_period: "Accumulated stocks during the period",
    Inventories_increased_during_the_period: 'Inventories increased during the period',
    Add_new_tax_rate: "Add new tax rate",
    Name: "Name",
    Description: "Description",
    Update: "Update",
    Add_new: "Add new",
    Cancel: "Cancel",
    Name_of_the_repository_using_the_service: "Name of the repository UTS",
    Address: "Address",
    Total_warehouse: "Total warehouse",
    Total_Camera: "Total Camera",
    New_installation_service: "New installation service",
    Connection_service: "Connection service",
    Total_number_of_FTTH_lines: "Total number of FTTH lines",
    New_installation: "New installation",
    Increase_more: "Increase",
    Total_at_the_end_of_the_period: "Total at the end of the period (Accumulated inventory + Increased inventory during the period)",
    Downloading_data_failed: "Loading data failed",
    The_feature_is_currently_in_development: "The feature is currently in development",
    Select_complete_information: "Select complete information marked with * to see total cost!",
    Select_the_number_of_months: "Select number of months",
    Select_the_starting_month: "Select the starting month",
    Total_cost: "Total cost",
    Select_a_time_to_see_the_total_cost: "Select a time to see the total cost!",
    Details_of_periods: "Details of periods",
    No_data_available_for_the_selected_period: "No data available for the selected period!",
    Select_a_period_to_view_period_details: "Select a period to view period details!",
    TOTAL_COSTS_FOR_THE_PERIOD: "TOTAL COSTS FOR THE PERIOD",
    VAT: "VAT TAX",
    TOTAL_AFTER_TAXES: "TOTAL AFTER TAXES",
    status: "Status",
    The_start_time_must_be_less_than_the_end_time: 'The start time must be less than the end time',
    Cannot_enter_more_than_155_characters: "Cannot enter more than 155 characters",
    Tax_rate: "tax rate",
    Tax_percentage: "Tax percentage",
    Time_applies_from: "TG applies from",
    Successfully_removed_tax_rate: "Successfully removed tax rate",
    Delete_tax_rate_failed: "Delete tax rate failed",
    Added_successfully: "Added successfully",
    New_add_failed: "New add failed",
    The_price_list_cannot_be_edited_while_it_is_in_use: "The price list cannot be edited while it is in use",
    Cannot_remove_tariff_while_in_use: "Cannot remove tariff while in use",
    Do_you_want_to_delete: "Do you want to delete?",
    Tax_percentage_limit_from_0_to_100: 'Tax percentage limit from 0% to 100%',
    Tax_code_cannot_be_a_negative_number: "Tax code cannot be a negative number",
    Edit: 'Edit',
    Camera_price: `Camera price`,
    Camera_prices_increased: "Camera prices increased",
    FTTH_price: "FTTH price",
    Usage_time: `Usage time`,
    Warehouse_type: "Warehouse type",
    default: "Default",
    Connection: "Connection",
    In_use: "In use",
    Not_yet_used: "Not yet used",
    Deleted_successfully: "Deleted successfully",
    Deleting_the_invoice_type_failed: "Deleting the invoice type failed",
    Add_invoice_type: "Add invoice type",
    Inner_city_price: `Inner city price`,
    Out_of_town_price: "Out of town price",
    New_installation_price_increased: "New installation price increased",
    Installation_dismantling_costs: "Installation/dismantling costs",
}
const history = {
    Device: 'Device',
    Access_history: "Access history",
    Configuration_type: 'Configuration type',
    Configuration_history: "Configuration history",
    User_history: "User history",
    Error_code: 'Error code',
    Error_history: "Error history"
}
const setting = {
    Please_turn_off_the_camera_to_edit_information: "Please turn off the camera to edit information",
    Please_enable_live_streaming: "Please turn on live streaming",
    Getting_list_of_subsource_resolutions_failed: "Failed to get list of subsource resolutions!",
    Get_configuration_failed: "Failed to get configuration",
    Number_of_days_retained_is_greater_than_default_number_of_days: "Number of days retained is greater than default",
    Turning_off_the_service_will_delete_all_AI_videos_of_this_camera: "Turning off the service will delete all AI videos of this camera!",
    Confirm_reset_to_default: "Confirm reset to default",
    Processing_parameters: "Processing parameters",
    Surveillance_area: "Surveillance area",
    Unsupervised_area: 'Unsupervised area monitor',
    Select_object: 'Select object',
    You_do_not_have_permission_to_configure_AI: "You do not have permission to configure AI",
    Setting: "Settings",
    Start_time_must_be_less_than_end_date: "Start time must be less than end date",
    Red_alert_time_is_greater_than: "Red alert time is greater than 0",
    Delete_records_when_service_is_turned_off: "Delete records when service is turned off",
    Zoom_in_on_screen_when_warning_is_detected: "Zoom in screen when warning is detected",
    Turn_on_sound: "Turn on sound",
    AI_Storage_Time: "AI Storage Time (Days)",
    Reset_to_default: "Reset to default",
    Configure_the_area_without: "Regional configuration without",
    Regional_configuration: "Regional configuration",
    Refresh_image: "Refresh image",
    Drawing: "Draw image",
    Remove_background: "Remove background",
    View_Partial: "View part",
    View_all: 'View all',
    Watchlist: 'Watchlist',
}

const param = {
    Lighting_conditions: "Lighting conditions",
    Sensitivity: "Sensitivity",
    Object_size: "Object size",
    Time_without_events: "Time without events",
    Minimum_event_time: "Minimum event time",
    Means_of_transport: "Transport",
    Accuracy_required: "Accuracy required",
    Frame_skipping_level: "Frame skipping level",
    Face_detection_sensitivity: "Face detection sensitivity",
    Face_matching_threshold: "Face matching threshold",
    Left_and_right_tilt: "Left and right tilt",
    Head_tilt: 'Head tilt',
    Face_Re_verification_Time: "Face Reverification Time",
    Object_lifetime: "Object Lifetime",
    High: "High",
    Low: "Low",
    Medium: "Medium",
    Big: "Large",
    Small: "Small",
    Bottom_up: "Bottom up",
    Top_to_bottom: "Top down",
    Information: "Information",
    Serious: "Serious",
    Alarm_temperature: "Alarm temperature",
    Do_not_miss_out: "Do not miss out",
    Highest: "Highest"
}
const settingCam = {
    Enable_recording_successfully: "Successfully turned on recording",
    Turn_off_recording_successfully: "Successfully turned off recording",
    Successfully_turned_off_the_camera: "Successfully turned off the camera",
    You_do_not_have_permission_to_turn_the_camera_on_or_off: "You do not have permission to turn the camera on or off",
    Camera_turned_on_successfully: "Successfully turned on the camera",
    The_secondary_sources_cannot_be_the_same: "The secondary sources cannot be the same",
    You_do_not_have_permission_to_use_AI: "You do not have permission to use AI",
    The_system_is_processing_please_try_again_later: "The system is processing please try again later!",
    Record: "Record",
    Stream_mode: "Stream mode",
    Stream_protocol: "Stream protocol",
    Desktop_resolution: 'Desktop resolution',
    Recorded_storage_time_Days: "Recorded storage time (Days)",
    Time_frame_allowed: "Time frame allowed",
    Save_settings: "Save settings",
    Camera_company_does_not_support_service: "Camera company does not support service",
    You_do_not_have_AI_administration_rights: "You do not have AI administration rights",
    Unable_to_extract_recognition_areas: 'Unable to extract recognition areas',
    Retrieving_fire_alarm_configuration_failed: "Retrieving fire alarm configuration failed",
    No_images: 'No images',
}
const setupNotification = {
    Unread: "Unread",
    Read: "Read",
    Notification_Type: 'Notification type',
    Select_camera_to_view_settings_information: "Select camera to view settings information",
    System_warning: "System warning",
    Real_time: "Real time",
    minute: "minute",
    Notification_name: 'Notification name',
    Warning_color: 'Warning color',
    Warning_level: 'Warning level',
    Notification_time: 'Notification time',
    Apply_all: "Apply all",
    Apply_new: "Apply new",
    Company_name: "Company name",
    Sound: "Sound",
    Notification_channel_management: "Notification channel management",
    Account_Name: "Account name",
    Notification_channel: "Notification channel",
    Display_name: "Display name",
    Unit_name: 'Unit name',
}
const ticketManagement = {
    title: "Ticket Management",
    createTicket: "Create New Ticket",
    updateTicket: "Update Ticket",
    ticketList: "Ticket List",
    ticketId: "Ticket ID",
    residentInfo: "Resident Info / Location",
    incidentContent: "Incident Content",
    incidentType: "Incident Type",
    severity: "Severity",
    status: "Processing Status",
    action: "Action",
    update: "Update",
    viewDetail: "View Detail",
    all: "All",
    pending: "Pending",
    inProgress: "In Progress",
    resolved: "Resolved",
    critical: "Critical",
    normal: "Normal",
    low: "Low",
    search: "Search ticket...",
    todayStats: "TODAY STATISTICS",
    totalIncidents: "Total incidents",
    totalTypes: "Total incident types",
    byStatus: "Incidents by status",
    bySeverity: "Incidents by severity",
    residentAndLocation: "Resident & Location Info",
    selectApartment: "Select apartment",
    residentName: "Resident name",
    phoneNumber: "Phone number",
    publicArea: "Report from public area",
    specificLocation: "Specific location",
    feedbackDetail: "Feedback Detail",
    selectIncidentType: "Select incident type",
    subject: "Subject",
    detailedDescription: "Detailed description",
    descriptionHint: "Detailed description helps faster processing.",
    evidenceAndTime: "Evidence & Time",
    uploadAttachment: "Upload image/video",
    upload: "Upload",
    incidentStartTime: "Incident start time",
    residentAvailableTime: "Resident available time",
    responsibleDepartment: "Assignee",
    assignee: "Assignee",
    technical: "Technical",
    cleaning: "Cleaning",
    security: "Security",
    accounting: "Accounting",
    internalNote: "Internal note",
    optional: "Optional",
    saveDraft: "Save Draft",
    submit: "Submit",
    cancel: "Cancel",
    preview: "Preview",
    reset: "Reset",
    saveChanges: "Save Changes",
    sendReport: "Send Report",
    closeTicket: "Close Ticket",
    ticketInfo: "Ticket Info",
    residentInfoSection: "Resident Info",
    incidentDetail: "Incident Detail",
    updateHistory: "Update History",
    newUpdate: "New Update",
    newUpdatePlaceholder: "Enter new update content...",
    updateHint: "Detailed update helps faster processing.",
    processingSteps: "Processing Steps (5 Steps)",
    step1: "Receive",
    step2: "Classify",
    step3: "Plan",
    step4: "Fix",
    step5: "Close",
    quickDispatch: "Quick Dispatch",
    nextStep: "Move to next step",
    notifyResident: "Notify Resident",
    sendProgressNotification: "Send progress notification to resident",
    processingStats: "Processing Stats",
    estimatedTime: "Estimated time",
    estimatedCost: "Estimated cost",
    fixDetail: "Fix Detail",
    fixStartTime: "Fix start time",
    fieldMediaUpload: "Upload field photos/videos",
    securityCamera: "Security (Camera)",
    technicalWater: "Technical (Water)",
    technicalElevator: "Technical (Elevator)",
    technicalElectric: "Technical (Electric)",
    createSuccess: "Ticket created successfully!",
    updateSuccess: "Ticket updated successfully!",
    draftSuccess: "Draft saved successfully!",
    confirmClose: "Are you sure you want to close this ticket?",
}
export const en = {
    header, infoUser, changePassword, version, home, login, sideBar, dashboard, stream, location, playback, infoCamera, services, smartReport, faceDetect, licensePlate, cameraManager,
    cameraControl,
    history,
    setting,
    param,
    settingCam,
    setupNotification,
    ticketManagement
}